<div class="buttonbar">
    <button (click)="onClick()" [disabled]="isDisabled" class="button">{{ buttonText }}</button>
</div>
